module.exports = __webpack_public_path__ + "static/media/facebook.a4bd2d67.svg";